export const NATURAL_TALK_DRIVER_URL: string = 'bank://natural/';
export const LIVELY_TALK_DRIVER_URL: string = 'bank://lively/';
export const NATURAL_KEYWORD: string = 'Natural';
export const LIVELY_KEYWORD: string = 'Lively';
export const EMOTION_KEYWORD: string = 'Emotion';
export const MULTILINGUAL: string = 'Multilingual';

export const SUPPORTED_ELEVENLABS_LANGUAGES_FOR_AGENTS: string[] = [
    'Arabic',
    'Bulgarian',
    'Chinese',
    'Croatian',
    'Czech',
    'Danish',
    'Dutch',
    'English',
    'Filipino',
    'Finnish',
    'French',
    'German',
    'Greek',
    'Hebrew',
    'Hindi',
    'Hungarian',
    'Indonesian',
    'Italian',
    'Japanese',
    'Korean',
    'Malay',
    'Malayalam',
    'Norwegian',
    'Polish',
    'Portuguese',
    'Romanian',
    'Russian',
    'Slovak',
    'Spanish',
    'Swedish',
    'Tamil',
    'Turkish',
    'Ukrainian',
    'Vietnamese',
];

export const LIMITTED_SUPPORTED_LANGUAGES_FOR_AGENTS = ['Malayalam', 'Tamil'];

export const LANGUAGES_FOR_ELEVENLABS: string[] = [
    'Arabic',
    'Bulgarian',
    'Chinese',
    'Croatian',
    'Czech',
    'Danish',
    'Dutch',
    'English',
    'Filipino',
    'Finnish',
    'French',
    'German',
    'Greek',
    'Hebrew',
    'Hindi',
    'Hungarian',
    'Indonesian',
    'Italian',
    'Japanese',
    'Korean',
    'Malay',
    'Malayalam',
    'Norwegian',
    'Polish',
    'Portuguese',
    'Romanian',
    'Russian',
    'Slovak',
    'Spanish',
    'Swedish',
    'Tamil',
    'Turkish',
    'Ukrainian',
    'Vietnamese',
];
export const BULK_LIMIT = 25;
